import { render } from "./post-smtp-guide.vue?vue&type=template&id=4cecbb7c&scoped=true"
import script from "./post-smtp-guide.vue?vue&type=script&lang=js"
export * from "./post-smtp-guide.vue?vue&type=script&lang=js"

import "./post-smtp-guide.vue?vue&type=style&index=0&id=4cecbb7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cecbb7c"]])

export default __exports__